import { create } from "zustand";
const token = localStorage.getItem("token");
export const useAuthStore = create((set, get) => ({
  user: null,
  token: token,
  specifyPerson: null,
  requires2fa: false,
  error: null,
  setUser: (user) => set({ user }),
  setError: (error) => set({ error }),
  setToken: (token) => set({ token }),
  setSpecifyPerson: (specifyPerson) => set({ specifyPerson }),
  setRequires2fa: (requires2fa) => set({ requires2fa }),
  clearAuth: () => {
    localStorage.removeItem("token");
    return set({ user: null, token: null, specifyPerson: null });
  },
  isInternalAdmin: () => {
    const user = get("user");
    if ("user" in user && user.user && "email" in user.user) {
      if (user.user.email == "michal@katuscak.cz"
      || user.user.email == "pavel@janda.it"
      || user.user.email == "petr.neumann@exclusive-networks.cz"
      || user.user.email == "martina.jelinkova@exclusive-networks.cz"
      || user.user.email == "pavel.janda@exclusive-networks.cz"
      ) {
        return true;
      }
    }
    return false;
  },
  getCurrentLanguage: () => {
    const state = get();
    if (state.user && state.user.user && state.user.user.agenda_id) {
      const agendaId = state.user.user.agenda_id;
      // Map agenda_id to language code
      // 1 = CZ (Czech), 2 = SK (Slovak), 3 = EN (English)
      if (agendaId == 2) return "sk";
      if (agendaId == 3) return "en";
      return "cs"; // default Czech
    }
    return "cs"; // default Czech
  },
}));
